<template>
  <div class="faq-panel">
    <div class="help-title">Frequently asked questions</div>
    <ul class="faq-list">
      <li v-for="faq in faqs" v-bind:key="faq.id">
        <div class="help-block">
          <div class="help-link">{{faq.link}}</div>
          <div class="help-content" v-html="faq.content"></div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
  export default {
    name: 'ResetPasswordFAQ',
    data() {
      return {
        resetUrl: process.env.VUE_APP_RESET_PASSWORD_PAGE_URL,
        faqs: [
          {link: "Why can't I log in to my computer after I reset my password?",
          content: "If you reset your password while not connected to the Autodesk network (i.e., you are not connected via VPN or in the office), your password will be updated on Autodesk's servers, but not updated locally on your computer. To unlock your computer, log in with your old password. Contact the Enterprise Service Desk, +1-415-507-8888, for assistance in updating the password on your computer."}, 
          {link: "What if I am not registered with Authenticator?",
          content: "Resetting your password uses Microsoft Authenticator to verify your identity. If you don't have an active Authenticator account, please contact the Enterprise Service Desk, +1-415-507-8888, for assistance."},
          {link: "What if password reset cannot verify my identity?",
          content: "There are situations where it will not be possible to reset your password. If you encounter any issues, contact the Enterprise Service Desk, +1-415-507-8888."},
          {link: "Where can I find more information about resetting my password and password requirements?",
          content: "<p>Visit the FAQ for Passwords for password requirements, troubleshooting advice, and more.</p><p>Do you know your current password? You can change it without resetting it.</p>"}
        ],
      };
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .faq-panel /deep/ a{
    color: var(--tag-color) !important;
  }
  .faq-panel /deep/ a:hover{
    color: var(--secondary-color-hover) !important;
  }
  a:hover{
    text-decoration: underline !important;
    color: var(--secondary-color-hover) !important;
  }
  .faq-panel {
    padding: 70px 30px 70px 60px;
    max-width: 500px;
    min-height: calc(100vh - 124px);
  }

  @media (max-width: 767px) {
    .help-title {
      font-size: 20px;
    }
    .faq-panel {
      margin-bottom: 45px;
    }
  }
  .help-title {
    padding-bottom: 20px;
    font-size: 26px;
    color: #000000;
    font-family: artifaktElementBold;
  }
  .faq-list {
    padding: 0 0 15px 0;
    list-style: none;
  }
  .help-block {
    margin-bottom: 15px;
  }
  .help-content {
    font-size: 16px;
    color: #000000;
    margin: 0 0 30px 0;
    display: block;
    text-overflow: ellipsis;
  }
  .help-link{
    font-size: 16px;
    color: #000000;
    font-weight: bolder;
    font-family: artifaktElementBold;
  }
  @media (max-width: 576px) {
    .help-content {
      font-size: 14px;
    }
    .help-link{
      font-size: 14px;
    }
    .help-title {
      font-size: 20px;
    }
    .faq-panel {
      padding: 20px;
    }
  }
  @media (max-width: 400px) {
    .help-content {
      font-size: 12px;
    }
    .help-link{
      font-size: 14px;
    }
    .help-title {
      font-size: 20px;
    }
  }
</style>
